function getSearchStr(): string {
  return location.search;
}

function getParameterByName(name: string, url: string) {
  const regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)');
  const results = regex.exec(url);

  if (!results) return '';
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

const searchStr = getSearchStr();
const placementIdStr = getParameterByName('placements', searchStr);
const enableBread = getParameterByName('bread', searchStr) || false;

let placementIds = [];
if(placementIdStr !== ''){
  placementIds = placementIdStr.split(',');
}

const env = getParameterByName('env', searchStr) || 'prod';
const local =
  getParameterByName('local', searchStr) || false;
const apiLocal = getParameterByName('api-local', searchStr) || false;

const apiKey = getParameterByName('apiKey', searchStr);
const enableAnalytics =
  getParameterByName('enableAnalytics', searchStr) || false;

const apiHost = {
  dev: 'https://brands.alldata.net',
  devMockLocal: 'http://localhost:7878',
  devLocal: 'http://localhost:8081',
  qa: 'https://brands-az.adcsep.com',
  stage: 'https://brands-staging.kmsmep.com',
  prod: 'https://brands.kmsmep.com'
};

const host = {
  local: 'http://localhost:8081/',
  dev: 'https://brand-sdk.alldata.net/',
  qa: 'https://brand-sdk-az.adcsep.com/',
  stage: 'https://brand-sdk.kmsmep.com/',
  prod: 'https://brand-sdk.kmsmep.com/'
};
const analyticsHost = {
  dev: 'https://metrics.adcsep.com/ep',
  qa: 'https://metrics.adcsep.com/ep',
  prod: 'https://metrics.kmsmep.com/ep'
};

const apiKeyDefault = {
  dev: '32323678-7124-5be3-2de3-fa5585dd95b9',
  qa: '9961775a-9e87-4b8f-92e5-6acb24227e5d',
  prod: '8a9fcd35-7f4d-4e3c-a9cc-6f6e98064df7'
};

let config;
switch (env.toLowerCase()) {
  case 'dev':
    config = {
      host: host.dev,
      apiHost: apiHost.dev,
      analyticsUrl: analyticsHost.dev,
      apiKey: apiKey || apiKeyDefault.dev,
      loggingEnabled: true,
      disableCache: true,
      enableAnalytics: !!enableAnalytics
    };
    break;
  case 'dev-mock-local':
    config = {
      host: host.dev,
      apiHost: apiHost.devMockLocal,
      analyticsUrl: analyticsHost.dev,
      apiKey: apiKey || apiKeyDefault.dev,
      loggingEnabled: true,
      disableCache: true,
      enableAnalytics: !!enableAnalytics
    };
    break;
  case 'dev-local':
    config = {
      host: host.local,
      apiHost: apiHost.devLocal,
      analyticsUrl: analyticsHost.dev,
      apiKey: apiKey || apiKeyDefault.dev,
      loggingEnabled: true,
      disableCache: true,
      enableAnalytics: !!enableAnalytics,
      plugins:{
        bread:{
          enabled: true
        }
      }
    };
    break;
  case 'qa':
    config = {
      host: host.qa,
      env: 'QA',
      apiHost: apiHost.qa,
      analyticsUrl: analyticsHost.qa,
      apiKey: apiKey || apiKeyDefault.qa,
      loggingEnabled: true,
      disableCache: true,
      enableAnalytics: !!enableAnalytics,
      // fmcApiBaseUrl: 'https://fmc.stage.taivara.com',
    };
    break;
  case 'qa-ci':
    config = {
      host: host.qa,
      apiHost: apiHost.qa,
      analyticsUrl: analyticsHost.qa,
      apiKey: apiKey || apiKeyDefault.qa,
      loggingEnabled: true,
      disableCache: true,
      enableAnalytics: true
    };
    break;
  case 'qa-cache':
    config = {
      apiHost: 'https://api-cache.iad1.qa.blispay.com/',
      analyticsUrl: analyticsHost.qa,
      apiKey: apiKey || apiKeyDefault.qa,
      loggingEnabled: true,
      disableCache: true,
      enableAnalytics: !!enableAnalytics
    };
    break;
  case 'stage':
    config = {
      host: host.stage,
      apiHost: apiHost.stage,
      analyticsUrl: analyticsHost.qa,
      apiKey: apiKey || apiKeyDefault.qa,
      loggingEnabled: true,
      disableCache: true,
      enableAnalytics: true,
      env: 'STAGE'
    };
    break;
  case 'prod':
    config = {
      apiHost: apiHost.prod,
      fmcApiBaseUrl: 'https://fmc.int.taivara.com',
      apiKey: apiKey || apiKeyDefault.prod,
      loggingEnabled: true,
      disableCache: true,
      enableAnalytics: true,
      env: 'STAGE',
    };
    break;
  case 'prod-cache':
    config = {
      apiHost: 'https://api-cache.blispay.com/',
      apiKey: apiKey || apiKeyDefault.prod,
      loggingEnabled: true,
      disableCache: true,
      enableAnalytics: true
    };
    break;
}

if(local && local !== 'false'){
  config.host = host.dev;
}
if(apiLocal && apiLocal !== 'false'){
  config.apiHost = apiHost.devLocal;
}
if(enableBread && enableBread !== 'false'){
  config.plugins = {bread: {enabled:true}};
}
/*
 * User edited code to specify the target above
 * */
(window as any).blispayConfig = config;

const placements = [];
placementIds.forEach(placementId=>{
  const domEl = document.createElement('div');
  const placementParams = placementId.split(':');
  // ID:Amount:Location:Loyalty:storeNumber
  domEl.dataset.epPlacement = placementParams[0];

  if(placementParams.length > 1 &&  placementParams[1] !== ''){
    domEl.dataset.amount = placementParams[1];
  }
  if(placementParams.length > 2 &&  placementParams[2] !== ''){
    domEl.dataset.location = placementParams[2];
  }
  if(placementParams.length > 3 &&  placementParams[3] !== ''){
    domEl.dataset.loyaltyId = placementParams[3];
  }
  if(placementParams.length > 4 &&  placementParams[4] !== ''){
    domEl.dataset.storeNumber = placementParams[4];
  }
  console.log(placementParams);
  const placementObj = {...domEl.dataset};
  console.log(placementObj);
  const infoEl = document.createElement('p');
  infoEl.innerHTML = `
    placementId: ${placementObj.epPlacement} <br>
    amount: ${placementObj.amount} <br>
    location: ${placementObj.location} <br>
    loyaltyId: ${placementObj.loyaltyId} <br>
    storeNumber: ${placementObj.storeNumber} <br>
    <hr>
  `;
  const container = document.getElementById('dynamic-placements');
  if(container){

    container.appendChild(infoEl);
    container.appendChild(domEl);

  }
});
